'use strict'

exports = module.exports = require('./commonjs/ReactTimeAgo.js').default
exports['default'] = require('./commonjs/ReactTimeAgo.js').default